// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"310f9fa7f9260177","639":"9c9fc64676294da4"}[chunkId] + ".css";
};